const data = {
	alertIcon: 'Wantcpanel',
	alertTitle: 'Compare Plans',
	alertMessage:
		'Compare your AWS virtual private server by license and technical specs.',
};

export default data;
